import { Progress } from 'antd';

import { displayProgressPercentage } from '@src/packages/utils/functions/triggers/progress';

/**
 * A progress bar component that displays the progress percentage and status for a table row.
 * @param {number|string} percentage - The progress percentage (0-100).
 * @returns {JSX.Element} The rendered progress bar component.
 * @returns
 */
const TableProgress = ({ percentage }) => {
  const number = Number(percentage);
  const percentageFixed = displayProgressPercentage(number);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Progress
        percent={percentage}
        size="small"
        style={{ minWidth: '100px', margin: 0 }}
        showInfo={false}
      />
      {Number.isFinite(number) && number >= 100 ? (
        <div className="gx-d-flex gx-justify-content-center gx-align-items-center gx-bg-success gx-rounded-circle gx-p-1">
          <span className="material-symbols-outlined gx-text-white gx-fs-md">check</span>
        </div>
      ) : (
        <span>{percentageFixed}%</span>
      )}
    </div>
  );
};

export default TableProgress;
